module.exports = __webpack_public_path__ + "static/media/simplonbp-medium-webfont.a97eab4f.svg";